<template>
  <div class="alert alert-dismissible alert-success" role="alert" v-if="message">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "alert-message",
  props: {
    message: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>

</style>